
<div class="acerca-de-container">
    <h2>{{titulo}}</h2>

    <h5 class="subtitle">Producto</h5>

    <div class="campo">
        <label>ArmorAML:</label>
        <span>Versión {{ acercaDe.version }}</span>
    </div>

    <div class="campo">
        <label>Build:</label>
        <span>{{ acercaDe.build }}</span>
    </div>

    <div class="campo">
        <label>Website:</label>
        <span class="link" (click)="openHelpDesk(acercaDe.webSite)">
            {{ acercaDe.webSite }}
        </span>
    </div>

    <div class="campo">
        <label>Certificación:</label>
        <span>{{ acercaDe.certificate }}</span>
    </div>

    <hr style="border: 1px solid #ffffff88; width: 100%; margin-left: 0; margin-top: 60px; margin-bottom: 20px;">

    <div class="campo">
        <span>©{{currentYear}} {{ acercaDe.provider }}. Todos lo derechos reservados.</span>
    </div>
</div>